// import React, { useEffect, useState } from 'react';
// import PageContainer from 'src/components/container/PageContainer';
// import './ClientDetails.css';
// import { useLocation, useNavigate, useParams } from 'react-router';
// import DashboardCard2 from 'src/components/shared/DashboardCard2';
// import { useMain } from 'src/views/hooks/useMain';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import WhatsAppIcon from '@mui/icons-material/WhatsApp';

// import {
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Grid,
//   Button,
//   Box,
//   Typography,
//   CardContent,
//   Chip,
// } from '@mui/material';
// import DiscountMembershipDetail from './DiscountMembershipDetail';
// import ServiceMembershipDetail from './ServiceMembershipDetail';
// import { MessageData } from './messageData';
// import TextInputs from 'src/components/inputs/TextInputs';
// import RadioInputs from 'src/components/inputs/RadioInputs';
// import PackageDetails from 'src/views/Membership/OurPackages/PackageDetails';
// import { changeDateFormate } from 'src/utils/dateutils';
// import { Divider } from 'rsuite';
// import { Card } from 'reactstrap';

// export const maskData = (value, isMasked) => {
//   if (isMasked) {
//     const maskLength = Math.ceil(value?.length / 2);
//     return '*'.repeat(maskLength) + value.substring(maskLength);
//   } else {
//     return value;
//   }
// };

// const initialUpatedData = {
//   clientName: '',
//   clientNumber: '',
//   clientAddress: '',
//   clientEmail: '',
//   gender: '',
//   birthday: '',
//   anniversary: '',
// };

// function ClientDetails() {
//   const { clientId } = useParams();

//   const [billData, setBillData] = useState([]);
//   const [data, setData] = useState({});
//   const [packageData, setPackageData] = useState({})
//   const [openDialogue, setOpenDialogue] = useState(false);
//   const [openDialogues, setOpenDialogues] = useState(false);
//   const [updatedClientId, setUpdateClientId] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [dialogLoading, setDialogLoading] = useState(false);
//   const [openPackageDialog, setOpenPackageDialog] = useState(false);

//   const [clientData, setClientData] = useState({});

//   const {
//     updateClient,
//     setShowMessage,
//     branchData,
//     activeBranchId,
//     fetchClientById,
//     fetchBillByClientNumber,
//   } = useMain();

//   const navigate = useNavigate();
//   const { state } = useLocation()

//   const [updatedClientData, setUpdatedClientData] = useState(initialUpatedData);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     if (name === 'address') {
//       setUpdatedClientData((prevData) => ({
//         ...prevData,
//         clientAddress: { [name]: value },
//       }));
//     } else {
//       setUpdatedClientData((prevData) => ({
//         ...prevData,
//         [name]: value,
//       }));
//     }
//   };

//   const handleCloseDialogue = () => {
//     setOpenDialogue(false);
//   };

//   const handleCloseDialogues = () => {
//     setOpenDialogues(false);
//   };
//   const handleOpenDialogues = () => {
//     setOpenDialogues(true);
//   };

//   const handleClosePackageDialog = () => {
//     setOpenPackageDialog(false);
//   };

//   const handleOpenPackageDialog = () => {
//     setOpenPackageDialog(true);
//   };

//   const handleUpdate = async (item) => {
//     setUpdateClientId(item._id);
//     setUpdatedClientData({
//       ...updatedClientData,
//       clientName: item?.clientName,
//       clientNumber: item?.clientNumber,
//       clientAddress: item?.clientAddress,
//       gender: item?.gender,
//       clientEmail: item?.clientEmail,
//       birthday: item?.birthday,
//       anniversary: item?.anniversary,
//     });
//     setOpenDialogue(true);
//   };

//   const hadleupdateClientData = async () => {
//     try {
//       setDialogLoading(true);
//       const res = await updateClient(
//         updatedClientId,
//         updatedClientData,
//         `?branchId=${activeBranchId}`,
//       );
//       if (res?.statusCode === 200) {
//         setShowMessage({
//           message: res.message || 'Client Details updated successfully',
//           messageType: 'success',
//         });
//         setOpenDialogue(false);
//         await getData(clientId);
//       } else {
//         setShowMessage({
//           message: res.message || 'Client Details not updated',
//           messageType: 'error',
//         });
//       }
//     } catch (error) {
//       setShowMessage({ message: error.message || 'Something Went Wrong', messageType: 'error' });
//     } finally {
//       setDialogLoading(false);
//     }
//   };

//   const handleSendMembershipDetails = () => {
//     let url = MessageData(data, branchData, 'membership');
//     window.open(url, '_blank');
//   };

//   const handleSendPackageDetails = () => {
//     let url = MessageData(data, branchData, 'package');
//     window.open(url, '_blank');
//   };

//   const getData = async (clientId) => {
//     try {
//       setLoading(true);
//       const res = await fetchClientById(clientId, `?branchId=${activeBranchId}`);
//       if (res.statusCode === 200) {
//         setData(res.data);
//         fetchBillData(res.data.clientNumber);
//       } else {
//       }
//     } catch (error) {
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchBillData = async (number) => {
//     try {
//       const resp = await fetchBillByClientNumber(number, `?branchId=${activeBranchId}`);
//       if (resp.statusCode === 200) {
//         setBillData(resp.data?.reverse());
//       }
//     } catch (error) { }
//   };
//   // console.log(data)

//   useEffect(() => {
//     if (clientId) getData(clientId);
//     return () => {
//       setData({});
//       setPackageData({})
//       setBillData([]);
//     };
//   }, [clientId, activeBranchId]);

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     const [year, month, day] = dateString.split('-');
//     return `${day}-${month}-${year}`;
//   };

//   return (
//     <>
//       <PageContainer title="Client Details" description="this is ClientDetails Page">
//         <DashboardCard2 title="Client Details">
//           {loading ? (
//             <ShowLoader />
//           ) : Object.keys(data).length > 0 ? (
//             <>
//               <button
//                 style={{
//                   display: 'flex',
//                   justifyContent: 'flex-end',
//                   alignItems: 'flex-end',
//                   float: 'right',
//                   backgroundColor: '#6174DD',
//                   padding: '10px 15px',
//                   color: '#fff',
//                   borderRadius: '5px',
//                   fontSize: '14px',
//                   border: 'none',
//                   marginRight: '20px',
//                 }}
//                 onClick={handleOpenDialogues}
//               >
//                 Membership
//               </button>

//               {/* package button */}
//               <button
//                 style={{
//                   display: 'flex',
//                   justifyContent: 'flex-end',
//                   alignItems: 'flex-end',
//                   float: 'right',
//                   backgroundColor: '#6174DD',
//                   padding: '10px 15px',
//                   color: '#fff',
//                   borderRadius: '5px',
//                   fontSize: '14px',
//                   border: 'none',
//                   marginRight: '20px',
//                 }}
//                 onClick={handleOpenPackageDialog}
//               >
//                 Package
//               </button>

//               {/* ---------------------- Client Details Dialog ---------------- */}
//               <Dialog open={openDialogue} onClose={handleCloseDialogue} maxWidth="md">
//                 <DialogTitle>Client Details</DialogTitle>
//                 <DialogContent>
//                   <DialogContentText>Here you can update client details.</DialogContentText>
//                   <Box style={{ marginTop: '20px' }}>
//                     <Grid container spacing={3}>
//                       <Grid item xs={12} md={4}>
//                         <TextInputs
//                           title={'Client Name'}
//                           name={'clientName'}
//                           value={updatedClientData?.clientName}
//                           handleChange={handleInputChange}
//                           type={'text'}
//                         />
//                       </Grid>
//                       <Grid item xs={12} md={4}>
//                         <TextInputs
//                           title={'Contact No'}
//                           name={'clientNumber'}
//                           value={updatedClientData?.clientNumber}
//                           handleChange={handleInputChange}
//                           type={'number'}
//                           maxLength={10}
//                         />
//                       </Grid>
//                       <Grid item xs={12} md={4}>
//                         <RadioInputs
//                           title={'Gender'}
//                           name={'gender'}
//                           value={updatedClientData?.gender}
//                           handleChange={handleInputChange}
//                           options={[
//                             { title: 'M', value: 'Male' },
//                             { title: 'F', value: 'Female' },
//                           ]}
//                         />
//                       </Grid>
//                     </Grid>
//                   </Box>
//                   <Box style={{ marginTop: '20px' }}>
//                     <Grid container spacing={3}>
//                       <Grid item xs={12} md={4}>
//                         <TextInputs
//                           required={false}
//                           title={'Email'}
//                           name={'clientEmail'}
//                           value={updatedClientData?.clientEmail}
//                           handleChange={handleInputChange}
//                           type={'email'}
//                         />
//                       </Grid>
//                       <Grid item xs={12} md={4}>
//                         <TextInputs
//                           required={false}
//                           title={'Address'}
//                           name={'address'}
//                           value={updatedClientData?.clientAddress?.address}
//                           handleChange={handleInputChange}
//                           type={'text'}
//                         />
//                       </Grid>

//                       <Grid item xs={12} md={4}>
//                         <TextInputs
//                           title={'BirthDay'}
//                           required={false}
//                           name={'birthday'}
//                           value={updatedClientData?.birthday}
//                           handleChange={handleInputChange}
//                           type={'date'}
//                         />
//                       </Grid>
//                     </Grid>
//                   </Box>
//                   <Box style={{ marginTop: '20px' }}>
//                     <Grid container spacing={3}>
//                       <Grid item xs={12} md={4}>
//                         <TextInputs
//                           required={false}
//                           title={'Anniversary'}
//                           name={'anniversary'}
//                           value={updatedClientData?.anniversary}
//                           handleChange={handleInputChange}
//                           type={'date'}
//                         />
//                       </Grid>
//                     </Grid>
//                   </Box>
//                 </DialogContent>
//                 <DialogActions>
//                   <>
//                     <div style={{ width: '200px', margin: '3rem auto' }}>
//                       <Button
//                         variant="contained"
//                         fullWidth
//                         color="primary"
//                         target="_blank"
//                         sx={{
//                           background: '#6174DD',
//                         }}
//                         onClick={handleCloseDialogue}
//                       >
//                         Cancel
//                       </Button>
//                     </div>
//                     <div style={{ width: '200px', margin: '3rem auto' }}>
//                       <Button
//                         variant="contained"
//                         fullWidth
//                         color="primary"
//                         target="_blank"
//                         sx={{
//                           background: '#6174DD',
//                         }}
//                         onClick={hadleupdateClientData}
//                       >
//                         update
//                       </Button>
//                     </div>
//                   </>
//                 </DialogActions>
//               </Dialog>

//               {/*--------- Memebership detail page------------------------------- */}
//               <Dialog
//                 open={openDialogues}
//                 onClose={handleCloseDialogues}
//                 maxWidth="sm"
//                 fullWidth
//                 sx={{
//                   '& .MuiDialog-paper': {
//                     width: '500px',
//                     maxWidth: '100%'
//                   }
//                 }}
//               >
//                 <DialogTitle>Membership Details</DialogTitle>
//                 <DialogContent>
//                   {data?.membershipDetails?.some(m => m.startDate && m.endDate) ? (
//                     <Box sx={{ maxHeight: '400px', overflowY: 'auto' }}>
//                       {data.membershipDetails
//                         .filter(m => m.startDate && m.endDate)
//                         .map((membership, index) => (
//                           <Card variant="outlined" sx={{ mb: 2 }} key={index}>
//                             <CardContent>
//                               <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
//                                 <Typography variant="h6" component="div">
//                                   {membership.membershipType === 'discountType'
//                                     ? 'Discount Membership'
//                                     : 'Service Membership'}
//                                 </Typography>
//                                 <Chip
//                                   label={membership.membershipType === 'discountType'
//                                     ? 'Discount'
//                                     : 'Service'}
//                                   color={membership.membershipType === 'discountType'
//                                     ? 'primary'
//                                     : 'secondary'}
//                                 />
//                               </Box>

//                               <Divider sx={{ my: 1 }} />

//                               {membership.membershipType === 'discountType' ? (
//                                 <Box sx={{ mb: 2 }}>
//                                   <Typography variant="body2" color="text.secondary">
//                                     <strong>Service Discount:</strong> {membership.discount?.discountOnService || '0'}
//                                     {membership.discount?.serviceDiscountType || '%'}
//                                   </Typography>
//                                   <Typography variant="body2" color="text.secondary">
//                                     <strong>Product Discount:</strong> {membership.discount?.discountOnProduct || '0'}
//                                     {membership.discount?.productDiscountType || '%'}
//                                   </Typography>
//                                   <Typography variant="body2" color="text.secondary">
//                                     <strong>Min Bill Amount:</strong> ₹{membership.discount?.minBillAmount || '0'}
//                                   </Typography>
//                                 </Box>
//                               ) : (
//                                 <Box sx={{ mb: 2 }}>
//                                   <Typography variant="subtitle2">Included Services:</Typography>
//                                   <Box component="ul" sx={{ pl: 2, mt: 0 }}>
//                                     {membership.services?.map((service, idx) => (
//                                       <Typography
//                                         key={idx}
//                                         variant="body2"
//                                         component="li"
//                                         color="text.secondary"
//                                       >
//                                         {service.serviceName} (Count: {service.count || '0'})
//                                       </Typography>
//                                     ))}
//                                   </Box>
//                                 </Box>
//                               )}

//                               <Typography variant="body2">
//                                 <strong>Validity:</strong> {formatDate(membership.startDate)} to {formatDate(membership.endDate)}
//                               </Typography>
//                             </CardContent>
//                           </Card>
//                         ))}
//                     </Box>
//                   ) : (
//                     <Box textAlign="center" py={4}>
//                       <Typography color="error" fontWeight="bold" fontSize={18}>
//                         No Membership Found
//                       </Typography>
//                     </Box>
//                   )}
//                 </DialogContent>
//                 <DialogActions sx={{ p: 3, gap: 2 }}>
//                   {dialogLoading ? (
//                     <ShowLoader value={dialogLoading} />
//                   ) : (
//                     <>
//                       <Button
//                         variant="outlined"
//                         color="primary"
//                         onClick={handleCloseDialogues}
//                         sx={{ minWidth: 120 }}
//                       >
//                         Close
//                       </Button>
//                       {data?.membershipDetails?.length > 0 ? (
//                         <Button
//                           variant="contained"
//                           startIcon={<WhatsAppIcon />}
//                           onClick={handleSendMembershipDetails}
//                           sx={{ minWidth: 140, backgroundColor: '#25D366' }}
//                         >
//                           WhatsApp
//                         </Button>
//                       ) : (
//                         <Button
//                           variant="contained"
//                           onClick={() => navigate('/memberships', {
//                             state: { clientNumber: data?.clientNumber }
//                           })}
//                           sx={{ minWidth: 120 }}
//                         >
//                           Buy Membership
//                         </Button>
//                       )}
//                     </>
//                   )}
//                 </DialogActions>
//               </Dialog>

//               {/* ---------------------- Package Details Dialog ---------------- */}
//               <Dialog
//                 open={openPackageDialog}
//                 onClose={handleClosePackageDialog}
//                 maxWidth="sm"
//                 fullWidth
//                 sx={{
//                   '& .MuiDialog-paper': {
//                     width: '500px',
//                     maxWidth: '100%'
//                   }
//                 }}
//               >
//                 <DialogTitle>Package Details</DialogTitle>
//                 <DialogContent>
//                   {data?.packageDetails?.length > 0 ? (
//                     <Box sx={{ maxHeight: '300px', overflowY: 'auto' }}>
//                       {data.packageDetails.map((packageDetail, index) => (
//                         <Card variant="outlined" sx={{ mb: 2 }} key={index}>
//                           <CardContent>
//                             <Typography variant="h6" component="div" gutterBottom>
//                               {packageDetail.packageName || 'Unnamed Package'}
//                             </Typography>

//                             <Divider sx={{ my: 1 }} />

//                             <Box sx={{ mb: 2 }}>
//                               <Typography variant="subtitle1" color="primary">
//                                 <strong>Price:</strong> ₹{packageDetail.price || '0'}
//                               </Typography>

//                               <Typography variant="subtitle2" gutterBottom sx={{ mt: 1 }}>
//                                 Included Services:
//                               </Typography>

//                               {packageDetail.services?.length > 0 ? (
//                                 <Box component="ul" sx={{ pl: 2, mt: 0 }}>
//                                   {packageDetail.services.map((service, idx) => (
//                                     <Typography
//                                       key={idx}
//                                       variant="body2"
//                                       component="li"
//                                       color="text.secondary"
//                                     >
//                                       {service.serviceName}
//                                     </Typography>
//                                   ))}
//                                 </Box>
//                               ) : (
//                                 <Typography variant="body2" color="text.secondary">
//                                   All services have been used
//                                 </Typography>
//                               )}
//                             </Box>

//                             <Typography variant="body2">
//                               <strong>Validity:</strong> {formatDate(packageDetail.startDate)} to {formatDate(packageDetail.validity)}
//                             </Typography>
//                           </CardContent>
//                         </Card>
//                       ))}
//                     </Box>
//                   ) : (
//                     <Box textAlign="center" py={4}>
//                       <Typography color="text.secondary">
//                         No Packages Available
//                       </Typography>
//                     </Box>
//                   )}
//                 </DialogContent>
//                 <DialogActions sx={{ p: 3 }}>
//                   <Button
//                     variant="contained"
//                     onClick={handleClosePackageDialog}
//                     sx={{ minWidth: 120 }}
//                   >
//                     Close
//                   </Button>
//                   {data?.packageDetails?.length > 0 && (
//                     <Button
//                       variant="contained"
//                       color="success"
//                       startIcon={<WhatsAppIcon />}
//                       onClick={handleSendPackageDetails}
//                       sx={{ minWidth: 140, backgroundColor: '#25D366' }}
//                     >
//                       WhatsApp
//                     </Button>
//                   )}
//                 </DialogActions>
//               </Dialog>

//               <div className="client-container">
//                 <div className="client-header">
//                   <div className="profile-img"></div>
//                   <div>
//                     <p className="client-text">Full Name</p>
//                     <h6 className="client-bold-title">{data?.clientName}</h6>
//                   </div>
//                 </div>
//                 <div className="row">
//                   <div className="col-6">
//                     {data?.clientEmail && (
//                       <div className="client-body">
//                         <p className="client-text">Email</p>
//                         <h6 className="client-title">{data?.clientEmail}</h6>
//                       </div>
//                     )}
//                     {data?.birthday && (
//                       <div className="client-body">
//                         <p className="client-text">Birthday</p>
//                         <h6 className="client-title">{changeDateFormate(data?.birthday)}</h6>
//                       </div>
//                     )}
//                     {data?.anniversary && (
//                       <div className="client-body">
//                         <p className="client-text">Anniversary</p>
//                         <h6 className="client-title">{changeDateFormate(data?.anniversary)}</h6>
//                       </div>
//                     )}
//                   </div>

//                   <div className="col-6">
//                     <div className="client-body">
//                       <p className="client-text">Mobile</p>
//                       <h6 className="client-title">
//                         {!data?.clientNumber || typeof branchData?.isMasked !== 'boolean'
//                           ? 'loading...'
//                           : maskData(data?.clientNumber, branchData?.isMasked)}
//                       </h6>
//                     </div>
//                     {data?.clientAddress?.address && (
//                       <div className="client-body">
//                         <p className="client-text">Address</p>
//                         <h6 className="client-title">{data?.clientAddress?.address}</h6>
//                       </div>
//                     )}
//                     <div className="client-body">
//                       <p className="client-text">Total Bill Amount</p>
//                       <h6 className="client-title">{data?.totalBillsAmount}</h6>
//                     </div>
//                     {data?.advancedGiven && (
//                       <div className="client-body">
//                         <p className="client-text">Remaining Wallet Balance </p>
//                         <h6 className="client-title">{data?.advancedGiven || 0}</h6>
//                       </div>
//                     )}
//                   </div>
//                 </div>

//                 <table className="table-container mt-5">
//                   <thead className="table-thead">
//                     <tr>
//                       <th style={{ width: '20%' }}>No</th>
//                       {[
//                         'Date of Bill',
//                         'Services',
//                         'Service Provider',
//                         'Products',
//                         'Previous Panding',
//                         'Total',
//                         'Paid',
//                         'Pending',
//                         'Bill',
//                       ].map((h, index) => {
//                         return (
//                           <th key={index} style={{ width: '100%' }}>
//                             {h}
//                           </th>
//                         );
//                       })}
//                     </tr>
//                   </thead>
//                   <tbody className="table-tbody">
//                     {billData !== undefined ? (
//                       billData?.map((bill, index) => {
//                         return (
//                           <tr key={bill?._id}>
//                             <td style={{ width: '20%', fontWeight: 'bold' }}>{index + 1}</td>
//                             <td style={{ width: '100%' }}>
//                               {changeDateFormate(bill?.dateOfBilling)}
//                             </td>
//                             <td style={{ width: '100%' }}>
//                               {bill?.services
//                                 ?.map((service) => service?.service?.serviceName)
//                                 .join(',  ')}
//                             </td>
//                             <td style={{ width: '100%' }}>
//                               {[
//                                 ...(bill?.services?.flatMap(
//                                   (s) => s?.serviceProvider?.map((p) => p?.name) || [],
//                                 ) || []),
//                                 ...(bill?.products
//                                   ?.map((p) => p?.providerStaff?.name)
//                                   ?.filter(Boolean) || []),
//                               ].join(', ')}
//                             </td>

//                             <td style={{ width: '100%' }}>
//                               {bill?.products?.map((product) => product?.productName).join(',  ')}
//                             </td>
//                             <td style={{ width: '100%' }}>{bill?.prePaidDues}</td>
//                             <td style={{ width: '100%' }}>{bill?.amountPayable}</td>
//                             <td style={{ width: '100%' }}>
//                               {bill?.amountPaid.reduce(
//                                 (acc, payment) => acc + Number(payment.amount),
//                                 0,
//                               )}
//                             </td>
//                             <td style={{ width: '100%' }}>{bill?.paidDues}</td>
//                             <td style={{ width: '100%' }}>
//                               <button
//                                 style={{
//                                   backgroundColor: '#6174DD',
//                                   fontSize: '14px',
//                                   fontWeight: 'bold',
//                                   color: '#fff',
//                                   border: 'none',
//                                   borderRadius: '8px',
//                                   padding: '5px 20px',
//                                   boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
//                                   transition: 'background-color 0.3s ease-in-out',
//                                 }}
//                                 onClick={() => navigate(`/billing/${bill._id}`)}
//                               >
//                                 Bill
//                               </button>
//                             </td>
//                           </tr>
//                         );
//                       })
//                     ) : (
//                       <tr>
//                         <td colSpan={5}> Data Not Found</td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </>
//           ) : (
//             'No data found'
//           )}
//         </DashboardCard2>
//       </PageContainer>
//     </>
//   );
// }

// export default ClientDetails;

import React, { useEffect, useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import './ClientDetails.css';
import { useLocation, useNavigate, useParams } from 'react-router';
import DashboardCard2 from 'src/components/shared/DashboardCard2';
import { useMain } from 'src/views/hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Button,
  Box,
  Typography,
  Chip,
  CardContent,
  Tab,
  Tabs,
} from '@mui/material';
import DiscountMembershipDetail from './DiscountMembershipDetail';
import ServiceMembershipDetail from './ServiceMembershipDetail';
import { MessageData } from './messageData';
import TextInputs from 'src/components/inputs/TextInputs';
import RadioInputs from 'src/components/inputs/RadioInputs';
import PackageDetails from 'src/views/Membership/OurPackages/PackageDetails';
import { changeDateFormate, changeTimeFormate } from 'src/utils/dateutils';
import { Divider } from 'rsuite';
import { Card } from 'reactstrap';
import { FiFilter } from 'react-icons/fi';
import ClientBillFilter from './ClientBillFilter';

export const maskData = (value, isMasked) => {
  if (isMasked) {
    const maskLength = Math.ceil(value?.length / 2);
    return '*'.repeat(maskLength) + value.substring(maskLength);
  } else {
    return value;
  }
};

const initialUpatedData = {
  clientName: '',
  clientNumber: '',
  clientAddress: '',
  clientEmail: '',
  gender: '',
  birthday: '',
  anniversary: '',
};

function ClientDetails() {
  const { clientId } = useParams();

  const [billData, setBillData] = useState([]);
  const [data, setData] = useState({});
  const [packageData, setPackageData] = useState({})
  const [openDialogue, setOpenDialogue] = useState(false);
  const [openDialogues, setOpenDialogues] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dialogLoading, setDialogLoading] = useState(false);
  const [openPackageDialog, setOpenPackageDialog] = useState(false); // State for package dialog
  const [updatedClientId, setUpdateClientId] = useState('');
  const [activeTab, setActiveTab] = useState('bills'); // 0 for Bills, 1 for Wallet
  const [packageBillData, setPackageBillData] = useState([]);
  const [membershipData, setMembershipData] = useState([]);
  const [walletData, setWalletData] = useState([]);
  const [hoveredItemId, setHoveredItemId] = useState(null);
  const [openBillHistoryDialog, setOpenBillHistoryDialog] = useState(false);
  const [selectedBill, setSelectedBill] = useState(null);
   const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({ services: [], products: [], categories: [] });

  const {
    updateClient,
    setShowMessage,
    branchData,
    activeBranchId,
    fetchClientById,
    fetchBillByClientNumber,
  } = useMain();

  const navigate = useNavigate();
  const { state } = useLocation()

  const [updatedClientData, setUpdatedClientData] = useState(initialUpatedData);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'address') {
      setUpdatedClientData((prevData) => ({
        ...prevData,
        clientAddress: { [name]: value },
      }));
    } else {
      setUpdatedClientData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleCloseDialogue = () => {
    setOpenDialogue(false);
  };

  const handleCloseDialogues = () => {
    setOpenDialogues(false);
  };
   const handleOpenBillHistory = (bill) => {
    setSelectedBill(bill);
    setOpenBillHistoryDialog(true);
  };

  const handleCloseBillHistory = () => {
    setOpenBillHistoryDialog(false);
    setSelectedBill(null);
  };
  const handleOpenDialogues = () => {
    setOpenDialogues(true);
  };

   const handleApplyFilter = (filters) => {
    setAppliedFilters(filters);
  };

  const handleClosePackageDialog = () => {
    setOpenPackageDialog(false);
  };

  const handleOpenPackageDialog = () => {
    setOpenPackageDialog(true);
  };

  const hadleupdateClientData = async () => {
    try {
      setDialogLoading(true);
      const res = await updateClient(
        updatedClientId,
        updatedClientData,
        `?branchId=${activeBranchId}`,
      );
      if (res?.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Client Details updated successfully',
          messageType: 'success',
        });
        setOpenDialogue(false);
        await getData(clientId);
      } else {
        setShowMessage({
          message: res.message || 'Client Details not updated',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Something Went Wrong', messageType: 'error' });
    } finally {
      setDialogLoading(false);
    }
  };

  // const handleSendMembershipDetails = () => {
  //   let url = MessageData(data, branchData);
  //   window.open(url, '_blank');
  // };

  // const handleSendPackageDetails = () => {
  //   let url = MessageData(data, branchData,);
  //   window.open(url, '_blank');
  // };
  const handleSendMembershipDetails = () => {
    let url = MessageData(data, branchData, 'membership');
    window.open(url, '_blank');
  };

  const handleSendPackageDetails = () => {
    let url = MessageData(data, branchData, 'package');
    window.open(url, '_blank');
  };


  const getData = async (clientId) => {
    try {
      setLoading(true);
      const res = await fetchClientById(clientId, `?branchId=${activeBranchId}`);
      if (res.statusCode === 200) {
        setData(res.data);
        fetchBillData(res.data?.clientNumber);
      } else {
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const fetchBillData = async (number) => {
    try {
      const resp = await fetchBillByClientNumber(number, `?branchId=${activeBranchId}`);
      if (resp.statusCode === 200) {
        // Separate bills and wallet transactions
        const bills = resp.data.serviceProductWalletBills.filter((bill) => bill.billType === 'Bill').reverse();
        const walletTransactions = resp.data.serviceProductWalletBills
          .filter((bill) => bill.billType === 'Wallet')
          .reverse();
        const allPackageBills = resp.data.membershipPackageBills
          .filter((bill) => bill.billType === 'Package')
          .reverse();
        const allMembershipBills = resp.data.membershipPackageBills
          .filter((bill) => bill.billType === 'Membership')
          .reverse();
        setBillData(bills);
        setWalletData(walletTransactions);
        setMembershipData(allMembershipBills);
        setPackageBillData(allPackageBills);
      }
    } catch (error) { }
  };

  useEffect(() => {
    if (clientId) getData(clientId);
    return () => {
      setData({});
      setPackageData({})
      setBillData([]);
      setWalletData([]);
    };
  }, [clientId, activeBranchId]);

  // Format date to DD-MM-YYYY
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const filteredBillData = billData.filter((bill) => {
    const { services: selectedServices, products: selectedProducts, categories: selectedCategories } =
      appliedFilters;

    const servicesActive = selectedServices && selectedServices.length > 0;
    const productsActive = selectedProducts && selectedProducts.length > 0;
    const categoriesActive = selectedCategories && selectedCategories.length > 0;

    if (!servicesActive && !productsActive && !categoriesActive) {
      return true;
    }

    const billServiceIds = bill.services?.map((s) => s.service?._id) || [];
    const billProductIds = bill.products?.map((p) => p.product?._id) || [];
    const billCategories = bill.services?.map((s) => s.service?.category).filter(Boolean) || [];

    const serviceMatch = servicesActive
      ? selectedServices.some((sId) => billServiceIds.includes(sId))
      : false;
    const productMatch = productsActive
      ? selectedProducts.some((pId) => billProductIds.includes(pId))
      : false;
    const categoryMatch = categoriesActive ? billCategories.some((cat) => selectedCategories.includes(cat)) : false;

    return serviceMatch || productMatch || categoryMatch;
  });

  const filterCount = (appliedFilters.services?.length || 0) + (appliedFilters.products?.length || 0) + (appliedFilters.categories?.length || 0);



  return (
    <>
      <PageContainer title="Client Details" description="this is ClientDetails Page">
        <DashboardCard2 title="Client Details">
          {loading ? (
            <ShowLoader />
          ) : Object.keys(data).length > 0 ? (
            <>
              {/* <button
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                  float: 'right',
                  backgroundColor: '#6174DD',
                  padding: '10px 15px',
                  color: '#fff',
                  borderRadius: '5px',
                  fontSize: '14px',
                  border: 'none',
                }}
                onClick={() => handleUpdate(data)}
              >
                Update
              </button> */}

               <Button
                startIcon={<FiFilter />}
                sx={{
                  float: 'right',
                  backgroundColor: '#ffffffff',
                  color: '#000000ff',
                  border: '1px solid #4b5cc5',
                  marginRight: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  '&:hover': {
                    backgroundColor: '#4b5cc5',
                    color: '#fff',
                  },
                }}
                onClick={() => setOpenFilterDialog(true)}
              >
                Filter
                {filterCount > 0 && (
                  <Box
                    component="span"
                    sx={{
                      ml: 1,
                      backgroundColor: '#6174DD',
                      color: 'white',
                      borderRadius: '10px',
                      fontWeight: 500,
                      padding: '2px 8px',
                      fontSize: '12px',
                      minWidth: '20px',
                      textAlign: 'center',
                    }}
                  >
                    {filterCount}
                  </Box>
                )}
              </Button>

              {/* membership button */}
              <button
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                  float: 'right',
                  backgroundColor: '#6174DD',
                  padding: '10px 15px',
                  color: '#fff',
                  borderRadius: '5px',
                  fontSize: '14px',
                  border: 'none',
                  marginRight: '20px',
                }}
                onClick={handleOpenDialogues}
              >
                Membership
              </button>

              {/* package button */}
              <button
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                  float: 'right',
                  backgroundColor: '#6174DD',
                  padding: '10px 15px',
                  color: '#fff',
                  borderRadius: '5px',
                  fontSize: '14px',
                  border: 'none',
                  marginRight: '20px',
                }}
                onClick={handleOpenPackageDialog}
              >
                Package
              </button>

              {/* ---------------------- Client Details Dialog ---------------- */}
              <Dialog open={openDialogue} onClose={handleCloseDialogue} maxWidth="md">
                <DialogTitle>Client Details</DialogTitle>
                <DialogContent>
                  <DialogContentText>Here you can update client details.</DialogContentText>
                  <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={4}>
                        <TextInputs
                          title={'Client Name'}
                          name={'clientName'}
                          value={updatedClientData?.clientName}
                          handleChange={handleInputChange}
                          type={'text'}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <TextInputs
                          title={'Contact No'}
                          name={'clientNumber'}
                          value={updatedClientData?.clientNumber}
                          handleChange={handleInputChange}
                          type={'number'}
                          maxLength={10}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <RadioInputs
                          title={'Gender'}
                          name={'gender'}
                          value={updatedClientData?.gender}
                          handleChange={handleInputChange}
                          options={[
                            { title: 'M', value: 'Male' },
                            { title: 'F', value: 'Female' },
                          ]}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                  <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={4}>
                        <TextInputs
                          required={false}
                          title={'Email'}
                          name={'clientEmail'}
                          value={updatedClientData?.clientEmail}
                          handleChange={handleInputChange}
                          type={'email'}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <TextInputs
                          required={false}
                          title={'Address'}
                          name={'address'}
                          value={updatedClientData?.clientAddress?.address}
                          handleChange={handleInputChange}
                          type={'text'}
                        />
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <TextInputs
                          title={'BirthDay'}
                          required={false}
                          name={'birthday'}
                          value={updatedClientData?.birthday}
                          handleChange={handleInputChange}
                          type={'date'}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                  <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={4}>
                        <TextInputs
                          required={false}
                          title={'Anniversary'}
                          name={'anniversary'}
                          value={updatedClientData?.anniversary}
                          handleChange={handleInputChange}
                          type={'date'}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </DialogContent>
                <DialogActions>
                  <>
                    <div style={{ width: '200px', margin: '3rem auto' }}>
                      <Button
                        variant="contained"
                        fullWidth
                        color="primary"
                        target="_blank"
                        sx={{
                          background: '#6174DD',
                        }}
                        onClick={handleCloseDialogue}
                      >
                        Cancel
                      </Button>
                    </div>
                    <div style={{ width: '200px', margin: '3rem auto' }}>
                      <Button
                        variant="contained"
                        fullWidth
                        color="primary"
                        target="_blank"
                        sx={{
                          background: '#6174DD',
                        }}
                        onClick={hadleupdateClientData}
                      >
                        update
                      </Button>
                    </div>
                  </>
                </DialogActions>
              </Dialog>
              {/* ---------------------- Membership Details Dialog ---------------- */}
              <Dialog
                open={openDialogues}
                onClose={handleCloseDialogues}
                maxWidth="sm"
                fullWidth
                sx={{
                  '& .MuiDialog-paper': {
                    width: '500px',
                    maxWidth: '100%',
                  },
                }}
              >
                <DialogTitle>Membership Details</DialogTitle>
                <DialogContent>
                  {data?.membershipDetails?.some((m) => m.startDate && m.endDate) ? (
                    <Box sx={{ maxHeight: '400px', overflowY: 'auto' }}>
                      {data.membershipDetails
                        .filter((m) => m.startDate && m.endDate)
                        .map((membership, index) => (
                          <Card variant="outlined" sx={{ mb: 2 }} key={index}>
                            <CardContent>
                              <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                mb={1}
                              >
                                <Typography variant="h6" component="div">
                                  {membership.membershipType === 'discountType'
                                    ? membership?.membershipId?.membershipName
                                    : membership?.membershipId?.membershipName}
                                </Typography>
                                <Chip
                                  label={
                                    membership.membershipType === 'discountType'
                                      ? 'Discount'
                                      : 'Service'
                                  }
                                  color={
                                    membership.membershipType === 'discountType'
                                      ? 'primary'
                                      : 'secondary'
                                  }
                                />
                              </Box>

                              <Divider sx={{ my: 1 }} />

                              {membership.membershipType === 'discountType' ? (
                                <Box sx={{ mb: 2 }}>
                                  <Typography variant="body2" color="text.secondary">
                                    <strong>Service Discount:</strong>{' '}
                                    {membership.discount?.discountOnService || '0'}
                                    {membership.discount?.serviceDiscountType || '%'}
                                  </Typography>
                                  <Typography variant="body2" color="text.secondary">
                                    <strong>Product Discount:</strong>{' '}
                                    {membership.discount?.discountOnProduct || '0'}
                                    {membership.discount?.productDiscountType || '%'}
                                  </Typography>
                                  <Typography variant="body2" color="text.secondary">
                                    <strong>Min Bill Amount:</strong> ₹
                                    {membership.discount?.minBillAmount || '0'}
                                  </Typography>
                                </Box>
                              ) : (
                                <Box sx={{ mb: 2 }}>
                                  <Typography variant="subtitle2">Included Services:</Typography>
                                  <Box component="ul" sx={{ pl: 2, mt: 0 }}>
                                    {membership.services?.map((service, idx) => (
                                      <Typography
                                        key={idx}
                                        variant="body2"
                                        component="li"
                                        color="text.secondary"
                                      >
                                        {service.serviceName} (Count: {service.count || '0'})
                                      </Typography>
                                    ))}
                                  </Box>
                                </Box>
                              )}

                              <Typography variant="body2">
                                <strong>Validity:</strong> {formatDate(membership.startDate)} to{' '}
                                {formatDate(membership.endDate)}
                              </Typography>
                            </CardContent>
                          </Card>
                        ))}
                    </Box>
                  ) : (
                    <Box textAlign="center" py={4}>
                      <Typography color="error" fontWeight="bold" fontSize={18}>
                        No Membership Found
                      </Typography>
                    </Box>
                  )}
                </DialogContent>
                <DialogActions sx={{ p: 3, gap: 2 }}>
                  {dialogLoading ? (
                    <ShowLoader value={dialogLoading} />
                  ) : (
                    <>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={handleCloseDialogues}
                        sx={{ minWidth: 120 }}
                      >
                        Close
                      </Button>
                      {data?.membershipDetails?.length > 0 ? (
                        <Button
                          variant="contained"
                          startIcon={<WhatsAppIcon />}
                          onClick={handleSendMembershipDetails}
                          sx={{ minWidth: 140, backgroundColor: '#25D366' }}
                        >
                          WhatsApp
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          onClick={() =>
                            navigate('/memberships', {
                              state: { clientNumber: data?.clientNumber },
                            })
                          }
                          sx={{ minWidth: 120 }}
                        >
                          Buy Membership
                        </Button>
                      )}
                    </>
                  )}
                </DialogActions>
              </Dialog>

              {/* ---------------------- Package Details Dialog ---------------- */}
              <Dialog
                open={openPackageDialog}
                onClose={handleClosePackageDialog}
                maxWidth="sm"
                fullWidth
                sx={{
                  '& .MuiDialog-paper': {
                    width: '500px',
                    maxWidth: '100%',
                  },
                }}
              >
                <DialogTitle>Package Details</DialogTitle>
                <DialogContent>
                  {data?.packageDetails?.length > 0 ? (
                    <Box sx={{ maxHeight: '300px', overflowY: 'auto' }}>
                      {data.packageDetails.map((packageDetail, index) => (
                        <Card variant="outlined" sx={{ mb: 2 }} key={index}>
                          <CardContent>
                            <Typography variant="h6" component="div" gutterBottom>
                              {packageDetail.packageName || 'Unnamed Package'}
                            </Typography>

                            <Divider sx={{ my: 1 }} />

                            <Box sx={{ mb: 2 }}>
                              <Typography variant="subtitle1" color="primary">
                                <strong>Price:</strong> ₹{packageDetail.price || '0'}
                              </Typography>

                              <Typography variant="subtitle2" gutterBottom sx={{ mt: 1 }}>
                                Included Services:
                              </Typography>

                              {packageDetail.services?.length > 0 ? (
                                <Box component="ul" sx={{ pl: 2, mt: 0 }}>
                                  {packageDetail.services.map((service, idx) => (
                                    <Typography
                                      key={idx}
                                      variant="body2"
                                      component="li"
                                      color="text.secondary"
                                    >
                                      {service.serviceName}
                                    </Typography>
                                  ))}
                                </Box>
                              ) : (
                                <Typography variant="body2" color="text.secondary">
                                  All services have been used
                                </Typography>
                              )}
                            </Box>

                            <Typography variant="body2">
                              <strong>Validity:</strong> {formatDate(packageDetail.startDate)} to{' '}
                              {formatDate(packageDetail.validity)}
                            </Typography>
                          </CardContent>
                        </Card>
                      ))}
                    </Box>
                  ) : (
                    <Box textAlign="center" py={4}>
                      <Typography color="text.secondary">No Packages Available</Typography>
                    </Box>
                  )}
                </DialogContent>
                <DialogActions sx={{ p: 3 }}>
                  <Button
                    variant="contained"
                    onClick={handleClosePackageDialog}
                    sx={{ minWidth: 120 }}
                  >
                    Close
                  </Button>
                  {data?.packageDetails?.length > 0 && (
                    <Button
                      variant="contained"
                      color="success"
                      startIcon={<WhatsAppIcon />}
                      onClick={handleSendPackageDetails}
                      sx={{ minWidth: 140, backgroundColor: '#25D366' }}
                    >
                      WhatsApp
                    </Button>
                  )}
                </DialogActions>
              </Dialog>

               <Dialog
                open={openBillHistoryDialog}
                onClose={handleCloseBillHistory}
                maxWidth="lg"
                fullWidth
                sx={{
                  '& .MuiDialog-paper': {
                    width: '90%',
                    maxWidth: '600px',
                    maxHeight: '80vh',
                  },
                }}
              >
                <DialogTitle>Due Bill History</DialogTitle>
                <DialogContent>
                  <Box sx={{ maxHeight: '60vh', overflowY: 'auto', mt: 2 }}>
                    <table className="table-container">
                      <thead className="table-thead">
                        <tr>
                          <th style={{ width: '20%' }}>No</th>
                          {['Payment Date', 'Payment Time', 'Payment Method', 'Amount Paid'].map(
                            (h, index) => {
                              return (
                                <th key={index} style={{ width: '100%' }}>
                                  {h}
                                </th>
                              );
                            },
                          )}
                        </tr>
                      </thead>
                      <tbody className="table-tbody">
                        {selectedBill?.dueBillHistory?.length>0 ? (
                          selectedBill.dueBillHistory.map((payment, index) => {
                            return (
                              <tr key={index}>
                                <td style={{ width: '20%', fontWeight: 'bold' }}>{index + 1}</td>
                                <td style={{ width: '100%' }}>
                                  {changeDateFormate(payment.paymentDate)}
                                </td>
                                <td style={{ width: '100%' }}>{changeTimeFormate(payment.paymentTime) || 'N/A'}</td>
                                <td style={{ width: '100%' }}>{payment.paymentType}</td>
                                <td style={{ width: '100%' }}>{payment.paidAmount}</td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={8} style={{ textAlign: 'center' }}>
                              No Payment History Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </Box>
                </DialogContent>
                <DialogActions sx={{ p: 3 }}>
                  <Button
                    variant="contained"
                    onClick={handleCloseBillHistory}
                    sx={{ minWidth: 120 }}
                  >
                    Close
                  </Button>
                </DialogActions>
              </Dialog>

              <div className="client-container">
                <div className="client-header">
                  <div className="profile-img"></div>
                  <div>
                    <p className="client-text">Full Name</p>
                    <h6 className="client-bold-title">{data?.clientName}</h6>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    {data?.clientEmail && (
                      <div className="client-body">
                        <p className="client-text">Email</p>
                        <h6 className="client-title">{data?.clientEmail}</h6>
                      </div>
                    )}
                    {data?.birthday && (
                      <div className="client-body">
                        <p className="client-text">Birthday</p>
                        <h6 className="client-title">{changeDateFormate(data?.birthday)}</h6>
                      </div>
                    )}
                    {data?.anniversary && (
                      <div className="client-body">
                        <p className="client-text">Anniversary</p>
                        <h6 className="client-title">{changeDateFormate(data?.anniversary)}</h6>
                      </div>
                    )}
                    {data?.clientNote && (
                      <div className="client-body" style={{ maxHeight: '100px', overflowY: 'auto', whiteSpace: 'pre-wrap' }}>
                        <p className="client-text">Client Note</p>
                        <h6 className="client-title">{data?.clientNote}</h6>
                      </div>
                    )}
                  </div>

                  <div className="col-6">
                    <div className="client-body">
                      <p className="client-text">Mobile</p>
                      <h6 className="client-title">
                        {!data?.clientNumber || typeof branchData?.isMasked !== 'boolean'
                          ? 'loading...'
                          : maskData(data?.clientNumber, branchData?.isMasked)}
                      </h6>
                    </div>
                    {data?.clientAddress?.address && (
                      <div className="client-body">
                        <p className="client-text">Address</p>
                        <h6 className="client-title">{data?.clientAddress?.address}</h6>
                      </div>
                    )}

                    <div className="client-body">
                      <p className="client-text">Total Bill Amount</p>
                      <h6 className="client-title">{data?.totalBillsAmount}</h6>
                    </div>
                    {data?.advancedGiven && (
                      <div className="client-body">
                        <p className="client-text">Remaining Wallet Balance </p>
                        <h6 className="client-title">{data?.advancedGiven || 0}</h6>
                      </div>
                    )}
                  </div>
                </div>

                {/* <Box sx={{ width: '100%', mt: 4 }}>
                  <Tabs value={activeTab} onChange={handleTabChange} centered>
                    <Tab label="Bills" />
                    <Tab label="Wallet" />
                    <Tab label="Memberships" />
                    <Tab label="Packages" />
                  </Tabs>
                </Box> */}
                <Box
                  sx={{
                    width: '100%',
                    mt: 4,
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <ToggleButtonGroup
                    value={activeTab}
                    exclusive
                    onChange={handleTabChange}
                    sx={{
                      width: '90%',
                      maxWidth: '600px',
                      backgroundColor: 'transparent',
                      gap: '8px',
                      '& .MuiToggleButtonGroup-grouped': {
                        border: 0,
                        '&:not(:first-of-type)': {
                          borderRadius: '8px',
                          marginLeft: '0px',
                        },
                        '&:first-of-type': {
                          borderRadius: '8px',
                        },
                      },
                    }}
                  >
                    {[
                      { value: 'bills', label: 'Bills' },
                      { value: 'packages', label: 'Packages' },
                      { value: 'memberships', label: 'Memberships' },
                      { value: 'wallet', label: 'Wallet' },
                    ].map(({ value, label }) => (
                      <ToggleButton
                        key={value}
                        value={value}
                        sx={{
                          flex: 1,
                          py: 1.5,
                          px: 2,
                          textTransform: 'none',
                          fontSize: '0.875rem',
                          fontWeight: 600,
                          color: '#4A4A4A',
                          backgroundColor: '#F5F5F5',
                          border: '1px solid #E0E0E0',
                          borderRadius: '8px !important',
                          transition: 'all 0.3s ease',
                          '&.Mui-selected, &.Mui-selected:hover': {
                            color: '#FFFFFF',
                            backgroundColor: '#6174DD',
                            borderColor: '#6174DD',
                            boxShadow: '0 2px 8px rgba(97, 116, 221, 0.3)',
                          },
                          '&:hover': {
                            backgroundColor: '#E8EAF6',
                            borderColor: '#D1D5F0',
                          },
                          '&:not(:last-child)': {
                            marginRight: '8px',
                          },
                        }}
                      >
                        {label}
                      </ToggleButton>
                    ))}
                  </ToggleButtonGroup>
                </Box>

                {/* Bills Table */}
                {activeTab === 'bills' && (
                  <table className="table-container mt-3">
                    <thead className="table-thead">
                      <tr>
                        <th style={{ width: '20%' }}>No</th>
                        {[
                          'Date of Bill',
                          'Services',
                          'Service Provider',
                          'Products',
                          'Total',
                          'Paid',
                          'Pending',
                          'Bill',
                          'Due History'
                        ].map((h, index) => {
                          return (
                            <th key={index} style={{ width: '100%' }}>
                              {h}
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody className="table-tbody">
                      {billData.length > 0 ? (
                        filteredBillData?.map((bill, index) => {
                        // billData?.map((bill, index) => {
                          // Get all services for this bill
                          const allServices = [
                            ...(bill?.services
                              ?.map((s) => s?.service?.serviceName)
                              .filter(Boolean) || []),
                            ...(bill?.products?.map((p) => p?.productName).filter(Boolean) || []),
                          ];

                          // Get all providers for this bill
                          const allProviders = [
                            ...(bill?.services
                              ?.flatMap((s) => s?.serviceProvider?.map((p) => p?.name) || [])
                              .filter(Boolean) || []),
                            ...(bill?.products
                              ?.map((p) => p?.providerStaff?.name)
                              .filter(Boolean) || []),
                          ];

                          return (
                            <tr key={bill?._id}>
                              <td style={{ width: '20%', fontWeight: 'bold' }}>{index + 1}</td>
                              <td style={{ width: '100%' }}>
                                {changeDateFormate(bill?.dateOfBilling)}
                              </td>

                              {/* Services column with hover */}
                              <td style={{ width: '130%', position: 'relative' }}>
                                <div
                                  onMouseEnter={() => setHoveredItemId(bill._id + '_services')}
                                  onMouseLeave={() => setHoveredItemId(null)}
                                  style={{ cursor: 'pointer' }}
                                >
                                  {allServices.slice(0, 1).join(', ')}
                                  {allServices.length > 1 && ' ...'}

                                  {hoveredItemId === bill._id + '_services' && (
                                    <div
                                      style={{
                                        position: 'absolute',
                                        top: '100%',
                                        left: 0,
                                        backgroundColor: '#dfe3f8',
                                        border: '1px solid #ccc',
                                        padding: '8px',
                                        borderRadius: '5px',
                                        zIndex: 5,
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                                        whiteSpace: 'pre-wrap',
                                        maxWidth: '300px',
                                      }}
                                    >
                                      {allServices.join(', ')}
                                    </div>
                                  )}
                                </div>
                              </td>

                              {/* Service Providers column with hover */}
                              <td style={{ width: '100%', position: 'relative' }}>
                                <div
                                  onMouseEnter={() => setHoveredItemId(bill._id + '_providers')}
                                  onMouseLeave={() => setHoveredItemId(null)}
                                  style={{ cursor: 'pointer' }}
                                >
                                  {allProviders.slice(0, 1).join(', ')}
                                  {allProviders.length > 1 && ' ...'}

                                  {hoveredItemId === bill._id + '_providers' && (
                                    <div
                                      style={{
                                        position: 'absolute',
                                        top: '100%',
                                        left: 0,
                                        backgroundColor: '#dfe3f8',
                                        border: '1px solid #ccc',
                                        padding: '8px',
                                        borderRadius: '5px',
                                        zIndex: 5,
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                                        whiteSpace: 'pre-wrap',
                                        maxWidth: '300px',
                                      }}
                                    >
                                      {allProviders.join(', ')}
                                    </div>
                                  )}
                                </div>
                              </td>

                              <td style={{ width: '100%' }}>
                                {bill?.products?.map((product) => product?.productName).join(',  ')}
                              </td>

                              <td style={{ width: '100%' }}>{bill?.amountPayable}</td>
                              <td style={{ width: '100%' }}>
                                {bill?.amountPaid.reduce(
                                  (acc, payment) => acc + Number(payment.amount),
                                  0,
                                )}
                              </td>
                              <td style={{ width: '100%' }}>{bill?.paidDues}</td>
                              <td style={{ width: '100%' }}>
                                <button
                                  style={{
                                    backgroundColor: '#6174DD',
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '8px',
                                    padding: '5px 20px',
                                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                                    transition: 'background-color 0.3s ease-in-out',
                                  }}
                                  onClick={() => navigate(`/billing/${bill._id}`)}
                                >
                                  Bill
                                </button>
                              </td>
                               <td style={{ width: '100%',display:'flex' }}>
                                {bill?.dueBillHistory?.length > 0 ? (
                                  <button
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'flex-end',
                                      alignItems: 'flex-end',
                                      float: 'right',
                                      backgroundColor: '#6174DD',
                                      padding: '10px 15px',
                                      color: '#fff',
                                      borderRadius: '5px',
                                      fontSize: '14px',
                                      border: 'none',
                                      // marginRight: '20px',
                                    }}
                                    onClick={() => handleOpenBillHistory(bill)}
                                  >
                                    Due History
                                  </button>
                                ) : (
                                  'No History Available'
                                )}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={9} style={{ textAlign: 'center' }}>
                            No Bills Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}

                {/* Wallet Table */}
                {activeTab === 'wallet' && (
                  <table className="table-container mt-3">
                    <thead className="table-thead">
                      <tr>
                        <th style={{ width: '20%' }}>No</th>
                        {['Date', 'Amount Paid', 'Value of Amount', 'Action'].map((h, index) => {
                          return (
                            <th key={index} style={{ width: '100%' }}>
                              {h}
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody className="table-tbody">
                      {walletData.length > 0 ? (
                        walletData?.map((wallet, index) => {
                          return (
                            <tr key={wallet?._id}>
                              <td style={{ width: '20%', fontWeight: 'bold' }}>{index + 1}</td>
                              <td style={{ width: '100%' }}>
                                {changeDateFormate(wallet?.dateOfBilling)}
                              </td>
                              <td style={{ width: '100%' }}>{wallet?.amountPayable}</td>
                              <td style={{ width: '100%' }}>
                                {wallet?.amountAdded || wallet?.amountPayable}
                              </td>
                              <td style={{ width: '100%' }}>
                                <button
                                  style={{
                                    backgroundColor: '#6174DD',
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '8px',
                                    padding: '5px 20px',
                                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                                    transition: 'background-color 0.3s ease-in-out',
                                  }}
                                  onClick={() => navigate(`/billing/${wallet._id}`)}
                                >
                                  View
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={4} style={{ textAlign: 'center' }}>
                            No Wallet Transactions Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
                {activeTab === 'memberships' && (
                  <table className="table-container mt-3">
                    <thead className="table-thead">
                      <tr>
                        <th style={{ width: '20%' }}>No</th>
                        {[
                          'Date of Bill',
                          'Membership Name',
                          'Service Provider',
                          'Membership Type',
                          'Total',
                          'Paid',
                          'Pending',
                          'Bill',
                        ].map((h, index) => {
                          return (
                            <th key={index} style={{ width: '100%' }}>
                              {h}
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody className="table-tbody">
                      {membershipData.length > 0 ? (
                        membershipData?.map((bill, index) => {
                          // Get all providers for this bill
                          const allProviders = [
                            ...(bill?.memberships
                              ?.flatMap((s) => s?.serviceProvider?.map((p) => p?.name) || [])
                              .filter(Boolean) || []),
                          ];

                          return (
                            <tr key={bill?._id}>
                              <td style={{ width: '20%', fontWeight: 'bold' }}>{index + 1}</td>
                              <td style={{ width: '100%' }}>
                                {changeDateFormate(bill?.dateOfBilling)}
                              </td>

                              {/* Services column with hover */}
                              <td style={{ width: '100%', position: 'relative' }}>
                                {/* <div
                                  onMouseEnter={() => setHoveredItemId(bill._id + '_services')}
                                  onMouseLeave={() => setHoveredItemId(null)}
                                  style={{ cursor: 'pointer' }}
                                >
                                  {allServices.slice(0, 1).join(', ')}
                                  {allServices.length > 1 && ' ...'}

                                  {hoveredItemId === bill._id + '_services' && (
                                    <div
                                      style={{
                                        position: 'absolute',
                                        top: '100%',
                                        left: 0,
                                        backgroundColor: '#dfe3f8',
                                        border: '1px solid #ccc',
                                        padding: '8px',
                                        borderRadius: '5px',
                                        zIndex: 5,
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                                        whiteSpace: 'pre-wrap',
                                        maxWidth: '300px',
                                      }}
                                    >
                                      {allServices.join(', ')}
                                    </div>
                                  )}
                                </div> */}
                                {bill.membershipDetails.membershipName}
                              </td>

                              {/* Service Providers column with hover */}
                              <td style={{ width: '100%', position: 'relative' }}>
                                <div
                                  onMouseEnter={() => setHoveredItemId(bill._id + '_providers')}
                                  onMouseLeave={() => setHoveredItemId(null)}
                                  style={{ cursor: 'pointer' }}
                                >
                                  {allProviders.slice(0, 1).join(', ')}
                                  {allProviders.length > 1 && ' ...'}

                                  {hoveredItemId === bill._id + '_providers' && (
                                    <div
                                      style={{
                                        position: 'absolute',
                                        top: '100%',
                                        left: 0,
                                        backgroundColor: '#dfe3f8',
                                        border: '1px solid #ccc',
                                        padding: '8px',
                                        borderRadius: '5px',
                                        zIndex: 5,
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                                        whiteSpace: 'pre-wrap',
                                        maxWidth: '300px',
                                      }}
                                    >
                                      {allProviders.join(', ')}
                                    </div>
                                  )}
                                </div>
                              </td>

                              <td style={{ width: '100%' }}>
                                {bill?.membershipDetails?.membershipType}
                              </td>

                              <td style={{ width: '100%' }}>{bill?.amountPayable}</td>
                              <td style={{ width: '100%' }}>
                                {bill?.amountPaid.reduce(
                                  (acc, payment) => acc + Number(payment.amount),
                                  0,
                                )}
                              </td>
                              <td style={{ width: '100%' }}>{bill?.paidDues ?? 0}</td>
                              <td style={{ width: '100%' }}>
                                <button
                                  style={{
                                    backgroundColor: '#6174DD',
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '8px',
                                    padding: '5px 20px',
                                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                                    transition: 'background-color 0.3s ease-in-out',
                                  }}
                                  onClick={() => navigate(`/billing/${bill._id}`)}
                                >
                                  Bill
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={9} style={{ textAlign: 'center' }}>
                            No Bills Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
                {activeTab === 'packages' && (
                  <table className="table-container mt-3">
                    <thead className="table-thead">
                      <tr>
                        <th style={{ width: '20%' }}>No</th>
                        {[
                          'Date of Bill',
                          'Package Name',
                          'Service Provider',
                          // 'Membership Type',
                          'Total',
                          'Paid',
                          'Pending',
                          'Bill',
                        ].map((h, index) => {
                          return (
                            <th key={index} style={{ width: '100%' }}>
                              {h}
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody className="table-tbody">
                      {packageBillData.length > 0 ? (
                        packageBillData?.map((bill, index) => {
                          // Get all providers for this bill
                          const allProviders = [
                            ...(bill?.packages
                              ?.flatMap((s) => s?.serviceProvider?.map((p) => p?.name) || [])
                              .filter(Boolean) || []),
                          ];

                          return (
                            <tr key={bill?._id}>
                              <td style={{ width: '20%', fontWeight: 'bold' }}>{index + 1}</td>
                              <td style={{ width: '100%' }}>
                                {changeDateFormate(bill?.dateOfBilling)}
                              </td>

                              {/* Services column with hover */}
                              <td style={{ width: '100%', position: 'relative' }}>
                                {/* <div
                                  onMouseEnter={() => setHoveredItemId(bill._id + '_services')}
                                  onMouseLeave={() => setHoveredItemId(null)}
                                  style={{ cursor: 'pointer' }}
                                >
                                  {allServices.slice(0, 1).join(', ')}
                                  {allServices.length > 1 && ' ...'}

                                  {hoveredItemId === bill._id + '_services' && (
                                    <div
                                      style={{
                                        position: 'absolute',
                                        top: '100%',
                                        left: 0,
                                        backgroundColor: '#dfe3f8',
                                        border: '1px solid #ccc',
                                        padding: '8px',
                                        borderRadius: '5px',
                                        zIndex: 5,
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                                        whiteSpace: 'pre-wrap',
                                        maxWidth: '300px',
                                      }}
                                    >
                                      {allServices.join(', ')}
                                    </div>
                                  )}
                                </div> */}
                                {bill.servicesPackage.packageName}
                              </td>

                              {/* Service Providers column with hover */}
                              <td style={{ width: '100%', position: 'relative' }}>
                                <div
                                  onMouseEnter={() => setHoveredItemId(bill._id + '_providers')}
                                  onMouseLeave={() => setHoveredItemId(null)}
                                  style={{ cursor: 'pointer' }}
                                >
                                  {allProviders.slice(0, 1).join(', ')}
                                  {allProviders.length > 1 && ' ...'}

                                  {hoveredItemId === bill._id + '_providers' && (
                                    <div
                                      style={{
                                        position: 'absolute',
                                        top: '100%',
                                        left: 0,
                                        backgroundColor: '#dfe3f8',
                                        border: '1px solid #ccc',
                                        padding: '8px',
                                        borderRadius: '5px',
                                        zIndex: 5,
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                                        whiteSpace: 'pre-wrap',
                                        maxWidth: '300px',
                                      }}
                                    >
                                      {allProviders.join(', ')}
                                    </div>
                                  )}
                                </div>
                              </td>

                              {/* <td style={{ width: '100%' }}>
                                {bill?.membershipDetails?.membershipType}
                              </td> */}

                              <td style={{ width: '100%' }}>{bill?.amountPayable}</td>
                              <td style={{ width: '100%' }}>
                                {bill?.amountPaid.reduce(
                                  (acc, payment) => acc + Number(payment.amount),
                                  0,
                                )}
                              </td>
                              <td style={{ width: '100%' }}>{bill?.paidDues ?? 0}</td>
                              <td style={{ width: '100%' }}>
                                <button
                                  style={{
                                    backgroundColor: '#6174DD',
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '8px',
                                    padding: '5px 20px',
                                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                                    transition: 'background-color 0.3s ease-in-out',
                                  }}
                                  onClick={() => navigate(`/billing/${bill._id}`)}
                                >
                                  Bill
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={9} style={{ textAlign: 'center' }}>
                            No Bills Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </div>
            </>
          ) : (
            'No data found'
          )}
        </DashboardCard2>
        <ClientBillFilter
          open={openFilterDialog}
          onClose={() => setOpenFilterDialog(false)}
          onApplyFilter={handleApplyFilter}
          appliedFilters={appliedFilters}
          clientId={clientId}
          billData={billData}
        />
      </PageContainer>
    </>
  );
}

export default ClientDetails;
